export enum ApplyTemplateStatus {
  APPLYING = 'applying',
  COMPLETE = 'complete',
  ERROR = 'error',
}

/** A template chosen for a draft, referenced by its UserFile id. */
export type SelectedTemplate = {
  /** The template's UserFile id (template_user_file_id). */
  fileId: string
  /** The template's display name, resolved from the UserFile. */
  name: string
}
